import api from 'src/Utils/api';
export var handleDeleteRow = function (rowId) { return api.delete("/summons/" + rowId); };
